import React from 'react';
import { SvgIcon, useTheme } from '@material-ui/core';

export default function StarCircle(props) {
  const { palette } = useTheme();
  const strokeColor = palette.scoreTier[1];

  return (
    <SvgIcon viewBox="0 0 40 40" {...props}>
      <>
        <path
          d="M36.6668 20C36.6668 10.7953 29.2048 3.33334 20.0002 3.33334C10.7954 3.33334 3.3335 10.7953 3.3335 20C3.3335 29.2047 10.7954 36.6667 20.0002 36.6667C29.2048 36.6667 36.6668 29.2047 36.6668 20Z"
          fill="none"
          stroke={strokeColor}
          strokeWidth="3.5"
          strokeLinejoin="round"
        />
        <path
          d="M19.1323 12.1716C19.4937 11.4983 20.5067 11.4983 20.868 12.1716L22.9988 16.1419C23.1402 16.4055 23.4058 16.5889 23.7135 16.6354L28.345 17.3358C29.13 17.4545 29.4428 18.368 28.8815 18.9025L25.5658 22.0595C25.3462 22.2687 25.2448 22.5648 25.2933 22.8565L26.024 27.2625C26.1478 28.0087 25.3285 28.5735 24.6197 28.2307L20.4423 26.2098C20.1645 26.0755 19.8358 26.0755 19.558 26.2098L15.3806 28.2307C14.6718 28.5735 13.8525 28.0087 13.9763 27.2625L14.7071 22.8565C14.7555 22.5648 14.6542 22.2687 14.4346 22.0595L11.1189 18.9025C10.5576 18.368 10.8704 17.4545 11.6554 17.3358L16.2869 16.6354C16.5945 16.5889 16.8602 16.4055 17.0015 16.1419L19.1323 12.1716Z"
          fill="none"
          stroke={strokeColor}
          strokeWidth="3.5"
          strokeLinejoin="round"
        />
      </>
    </SvgIcon>
  );
}
